/**
 * Кликабельная карточка/баннер целиком (`data-card-link`).
 *
 * Клик по любому месту карточки ВНЕ её ссылок и кнопок срабатывает как клик
 * по главному элементу карточки. Главный элемент — по селектору из значения
 * атрибута (`data-card-link=".x"`), по умолчанию первый `a[href]`. Это может
 * быть и КНОПКА — например, триггер поп-апа (`data-card-link=".card__more"`;
 * на lymphomyosot так работала карточка продукта 09–13.10.2026, потом заказчик
 * вернул ссылку на страницу продукта, а поп-ап — только с плашки рейтинга).
 * Сами кнопки остаются обычными ссылками: клавиатура,
 * «открыть в новой вкладке», вторая кнопка карточки — всё работает как раньше.
 *
 * Почему не CSS-«растянутая ссылка» (::after кнопки на всю карточку): ей
 * нужен containing block = карточка, то есть у промежуточных обёрток надо
 * снять position. В баннерах проекта текст держится поверх абсолютной
 * картинки именно своим position: relative — без него он уходит под фото.
 *
 * Клик после свайпа в слайдере не срабатывает: Swiper гасит его на
 * контейнере в фазе перехвата раньше, чем событие дойдёт до карточки.
 * Выделение текста мышью — тоже не переход.
 */
itsoftApp.createModule("cardLink", function () {
    const module = this;
    const CARD = "[data-card-link]";
    const OWN_CONTROLS = "a, button, input, select, textarea, label, [role=button]";

    const primaryLink = function (card) {
        const selector = card.getAttribute("data-card-link") || "a[href]";
        const link = card.querySelector(selector);

        if (!link) {
            return null;
        }

        // Кнопка (поп-ап, раскрытие) — главный элемент как есть; у ссылки
        // пустой адрес и заглушка "#" — без перехода.
        if (link.tagName !== "A") {
            return link;
        }

        const href = link.getAttribute("href");

        return href && href !== "#" ? link : null;
    };

    const onClick = function (event) {
        if (event.defaultPrevented || event.button > 0) {
            return;
        }

        const target = event.target;
        const card = target && target.closest ? target.closest(CARD) : null;

        if (!card || target.closest(OWN_CONTROLS)) {
            return;
        }

        const selection = window.getSelection ? String(window.getSelection()) : "";

        if (selection) {
            return;
        }

        const link = primaryLink(card);

        if (!link) {
            return;
        }

        // Ctrl/Cmd/Shift-клик по карточке — как по ссылке: в новой вкладке.
        if (link.tagName === "A" && (event.ctrlKey || event.metaKey || event.shiftKey)) {
            window.open(link.href, "_blank", "noopener");
            return;
        }

        link.click(); // уважает target/rel самой ссылки; у кнопки — её обработчики
    };

    module.primaryLink = primaryLink;

    if (!document.querySelector(CARD)) {
        return false;
    }

    document.addEventListener("click", onClick);
});
